import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import I18n from 'PMT/i18n/I18n';
import Switch from 'react-bootstrap-switch';
import SecurityContext from 'utils/permissions/SecurityContext';
// -- entities
import Restaurant from 'PMT/entities/Restaurant';
import RestaurantMultipart from 'PMT/entities/RestaurantMultipart';
// -- views
import RestaurantFormComponent from './RestaurantFormComponent';
import StoreStateChooser from "components/form/StoreStateChooser"
import { POSChooser, TextInput, PasswordInput } from 'PMT/components/form';

export default class AdminFormView extends RestaurantFormComponent {
  static propTypes = {
    restaurant: PropTypes.objectOf(Restaurant),

    /**
     * @param RestaurantMultipart
     */
    onUpdate: PropTypes.func.isRequired,
  };

  state = this.getDefaultState(this.props.restaurant);

  //
  // RestaurantFormComponent override.
  //

  getDefaultState(restaurant: Restaurant) {
    return {
      externalId: restaurant.externalId,
      pos: restaurant.pos,
      posId: restaurant.posId,
      posUrl: restaurant.posUrl,
      posMenuId: restaurant.posMenuId,
      posCredentials: restaurant.posCredentials,
      posCustomerId: restaurant.posCustomerId,
      posCommentId: restaurant.posCommentId,
      posTipArticleId: restaurant.posTipArticleId,
      posPriceLevelId: restaurant.posPriceLevelId,
      posUseQsrOrderNumber: restaurant.posUseQsrOrderNumber,
      posSendArticleLineNum: restaurant.posSendArticleLineNum,
      posEncryptionKey: restaurant.posEncryptionKey,

      status: restaurant.status,

      restaurantName: restaurant.name,

      password: '',
      passwordVerification: '',
    };
  }

  haveModifications() {
    const restaurant: Restaurant = this.props.restaurant;
    const state = this.state;

    return !(
        state.externalId === restaurant.externalId &&
        state.pos === restaurant.pos &&
        state.posId === restaurant.posId &&
        state.posUrl === restaurant.posUrl &&
        state.posCustomerId === restaurant.posCustomerId &&
        state.posCommentId === restaurant.posCommentId &&
        state.posTipArticleId === restaurant.posTipArticleId &&
        state.posPriceLevelId === restaurant.posPriceLevelId &&
        state.posUseQsrOrderNumber === restaurant.posUseQsrOrderNumber &&
        state.posSendArticleLineNum === restaurant.posSendArticleLineNum &&
        state.posMenuId === restaurant.posMenuId &&
        state.posCredentials === restaurant.posCredentials &&
        state.posEncryptionKey === restaurant.posEncryptionKey &&
        state.status === restaurant.status &&
        restaurant.name === state.restaurantName &&
        _.isEmpty(state.password)
    );
  }

  //
  // form actions
  //

  //
  //
  //

  onExternalIdChange = (externalId: string) => {
    this.setState({
      externalId,
    });
  };

  onRestaurantNameChange = restaurantName => {
    this.setState({
      restaurantName,
    });
  };

  onStatusChange = (status) => {
    this.setState({
      status
    });
  };

  //
  // POS
  //

  onPosChange = (pos: string) => {
    this.setState({
      pos,
    });
  };

  onPosIdChange = (posId: string) => {
    this.setState({
      posId,
    });
  };

  onPosUrlChange = (posUrl: string) => {
    this.setState({
      posUrl,
    });
  };

  onPosCustomerIdChange = (posCustomerId: string) => {
    this.setState({
      posCustomerId,
    });
  };

  onPosCommentIdChange = (posCommentId: string) => {
    this.setState({
      posCommentId,
    });
  };

  onPosTipArticleIdChange = (posTipArticleId: string) => {
    this.setState({
      posTipArticleId
    })
  }

  onPosPriceLevelIdChange = (posPriceLevelId: string) => {
    this.setState({
      posPriceLevelId
    })
  }

  onPosUseQsrOrderNumberChange = () => {
    this.setState({
      posUseQsrOrderNumber: !this.state.posUseQsrOrderNumber
    })
  }

  onPosSendArticleLineNumChange = () => {
    this.setState({
      posSendArticleLineNum: !this.state.posSendArticleLineNum
    })
  }

  onPosMenuIdChange = (posMenuId: string) => {
    this.setState({
      posMenuId,
    });
  };

  onPosCredentialsChange = (posCredentials: string) => {
    this.setState({
      posCredentials,
    });
  };

  onPosEncryptionKeyChange = (posEncryptionKey: string) => {
    this.setState({
      posEncryptionKey,
    });
  };

  //
  // Password
  //

  onPasswordChange = (password: string) => {
    this.setState({
      password,
    });
  };

  onPasswordVerificationChange = (passwordVerification: string) => {
    this.setState({
      passwordVerification,
    });
  };

  //
  // submit
  //

  onSubmit = event => {
    event.preventDefault();

    const restaurantMultipart: RestaurantMultipart = new RestaurantMultipart();

    restaurantMultipart.name = this.state.restaurantName;

    restaurantMultipart.externalId = this.state.externalId;
    restaurantMultipart.pos = this.state.pos;
    restaurantMultipart.posId = this.state.posId;
    restaurantMultipart.posUrl = this.state.posUrl;
    restaurantMultipart.posMenuId = this.state.posMenuId;
    restaurantMultipart.posCredentials = this.state.posCredentials;
    restaurantMultipart.posCustomerId = this.state.posCustomerId;
    restaurantMultipart.posCommentId = this.state.posCommentId;
    restaurantMultipart.posTipArticleId = this.state.posTipArticleId;
    restaurantMultipart.posPriceLevelId = this.state.posPriceLevelId;
    restaurantMultipart.posUseQsrOrderNumber = this.state.posUseQsrOrderNumber;
    restaurantMultipart.posSendArticleLineNum = this.state.posSendArticleLineNum;
    restaurantMultipart.posEncryptionKey = this.state.posEncryptionKey;

    restaurantMultipart.status = this.state.status;

    restaurantMultipart.password = this.state.password;
    restaurantMultipart.passwordVerification = this.state.passwordVerification;

    this.props.onUpdate(restaurantMultipart);
  };

  //
  // renderers
  //

  //
  //
  //

  renderRestaurantName() {
    return (
      <div className="row form-group">
        <div className="required col-xs-4 control-label">
          <label>{I18n.tr('restaurant_edit.configuration.restaurant_name')}</label>
        </div>
        <div className="col-xs-6">
          <TextInput
            value={this.state.restaurantName}
            onChange={this.onRestaurantNameChange}
            placeholder=""
            required
            readOnly={!SecurityContext.restaurantSettings.editConfigurationGeneral()}
          />
        </div>
      </div>
    );
  }

  renderRestaurantId() {
    const restaurant = this.props.restaurant;
    return (
      <div className="row form-group">
        <div className="required col-xs-4 control-label">
          <label>{I18n.tr('restaurant_edit.configuration.restaurant_id')}</label>
        </div>
        <div className="col-xs-6">
          <TextInput value={restaurant.id} placeholder="" readOnly />
        </div>
      </div>
    );
  }

  renderExternalId() {
    return (
      <div className="row form-group">
        <div className="required col-xs-4 control-label">
          <label>{I18n.tr('restaurant_edit.configuration.external_id')}</label>
        </div>
        <div className="col-xs-6">
          <TextInput value={this.state.externalId} onChange={this.onExternalIdChange} placeholder="" autoComplete="off" />
        </div>
      </div>
    );
  }

  renderPassword() {
    if (!SecurityContext.restaurantSettings.editConfigurationGeneral()) {
      return null;
    }
    return (
      <div className="row form-group">
        <div className="required col-xs-4 control-label">
          <label>{I18n.tr('restaurant_edit.configuration.password')}</label>
        </div>
        <div className="col-xs-6">
          <PasswordInput
            onChange={this.onPasswordChange}
            value={this.state.password}
            autoComplete="off"
          />
        </div>
      </div>
    );
  }

  renderPasswordVerification() {
    if (!SecurityContext.restaurantSettings.editConfigurationGeneral()) {
      return null;
    }
    return (
      <div className="row form-group">
        <div className="required col-xs-4 control-label">
          <label>{I18n.tr('restaurant_edit.configuration.password_verification')}</label>
        </div>
        <div className="col-xs-6">
          <PasswordInput
            onChange={this.onPasswordVerificationChange}
            value={this.state.passwordVerification}
            autoComplete="off"
          />
        </div>
      </div>
    );
  }

  renderStatus() {
    const messages = {
      ENABLED: I18n.tr('restaurant_edit.configuration.statut.ENABLED.explain'),
      DISABLED: I18n.tr('restaurant_edit.configuration.statut.DISABLED.explain')
    }

    const message = messages[this.state.status]

    return (
      <div className="row form-group">
        <div className="col-xs-4 text-right">
          <label>{I18n.tr('restaurant_edit.configuration.status')}</label>
        </div>

        <div className="col-xs-6">
          <StoreStateChooser
            value={this.state.status}
            onChange={this.onStatusChange}
            disabled={
              (!SecurityContext.restaurantSettings.editConfigurationGeneral() &&
              !SecurityContext.restaurantSettings.editConfigurationGeneralActivation()) 
              // only admin can "un-archive" the store
              || (this.props.restaurant.status === 'ARCHIVED' && !SecurityContext.admin.isAdmin())
            }
            readOnly={!SecurityContext.restaurantSettings.editConfigurationPos()}
          />
          &nbsp;&nbsp;
          <span>{message}</span>
        </div>
      </div>
    );
  }

  //
  // POS
  //

  renderPos() {
    return (
      <div className="row form-group">
        <div className="col-xs-4 control-label">
          <label>{I18n.tr('restaurant_edit.configuration.pos')}</label>
        </div>

        <div className="col-xs-6">
          <POSChooser
            value={this.state.pos}
            onChange={this.onPosChange}
            readOnly={!SecurityContext.restaurantSettings.editConfigurationPos()}
          />
        </div>
      </div>
    );
  }

  renderPosUrl() {
    return (
      <div className="row form-group">
        <div className="col-xs-4 control-label">
          <label>{I18n.tr('restaurant_edit.configuration.pos.url')}</label>
        </div>

        <div className="col-xs-6">
          <TextInput
            placeholder=""
            value={this.state.posUrl}
            onChange={this.onPosUrlChange}
            readOnly={!SecurityContext.restaurantSettings.editConfigurationPos()}
          />
        </div>
      </div>
    );
  }

  renderPosId() {
    return (
      <div className="row form-group">
        <div className="col-xs-4 control-label">
          <label>{I18n.tr('restaurant_edit.configuration.pos.id')}</label>
        </div>

        <div className="col-xs-6">
          <TextInput
            placeholder=""
            value={this.state.posId}
            onChange={this.onPosIdChange}
            readOnly={!SecurityContext.restaurantSettings.editConfigurationPos()}
          />
        </div>
      </div>
    );
  }

  renderPosCustomerId() {
    return (
      <div className="row form-group">
        <div className="col-xs-4 control-label">
          <label>{I18n.tr('restaurant_edit.configuration.pos.customer_id')}</label>
        </div>

        <div className="col-xs-6">
          <TextInput
            placeholder=""
            value={this.state.posCustomerId}
            onChange={this.onPosCustomerIdChange}
            readOnly={!SecurityContext.restaurantSettings.editConfigurationPos()}
          />
        </div>
      </div>
    );
  }

  renderPosCommentId() {
    return (
      <div className="row form-group">
        <div className="col-xs-4 control-label">
          <label>{I18n.tr('restaurant_edit.configuration.pos.comment_id')}</label>
        </div>

        <div className="col-xs-6">
          <TextInput
            placeholder=""
            value={this.state.posCommentId}
            onChange={this.onPosCommentIdChange}
            readOnly={!SecurityContext.restaurantSettings.editConfigurationPos()}
          />
        </div>
      </div>
    );
  }

  
  renderPosTipArticleId() {
    return (
      <div className="row form-group">
        <div className="col-xs-4 control-label">
          <label>{I18n.tr('restaurant_edit.configuration.pos.tip_article_id')}</label>
        </div>

        <div className="col-xs-6">
          <TextInput
            placeholder=""
            value={this.state.posTipArticleId}
            onChange={this.onPosTipArticleIdChange}
            readOnly={!SecurityContext.restaurantSettings.editConfigurationPos()}
          />
        </div>
      </div>
    );
  }

  renderPosPriceLevelId() {
    return (
      <div className="row form-group">
        <div className="col-xs-4 control-label">
          <label>{I18n.tr('restaurant_edit.configuration.pos.price_level_id')}</label>
        </div>

        <div className="col-xs-6">
          <TextInput
              placeholder=""
              value={this.state.posPriceLevelId}
              onChange={this.onPosPriceLevelIdChange}
              readOnly={!SecurityContext.restaurantSettings.editConfigurationPos()}
          />
        </div>
      </div>
    );
  }

  renderPosUseQsrOrderNumber() {
    return (
        <div className="row form-group">
          <div className="col-xs-4 control-label">
            <label>{I18n.tr(
                'restaurant_edit.configuration.pos.use_qsr_order_number')}</label>
          </div>

          <div className="col-xs-6">
            <Switch
                value={this.state.posUseQsrOrderNumber}
                bsSize="mini"
                onChange={this.onPosUseQsrOrderNumberChange}
                disabled={!SecurityContext.restaurantSettings.editConfigurationPos()}
            />
          </div>
        </div>
    );
  }

  renderPosSendArticleLineNum() {
    return (
        <div className="row form-group">
          <div className="col-xs-4 control-label">
            <label>{I18n.tr(
                'restaurant_edit.configuration.pos.send_article_line_num')}</label>
          </div>

          <div className="col-xs-6">
            <Switch
                value={this.state.posSendArticleLineNum}
                bsSize="mini"
                onChange={this.onPosSendArticleLineNumChange}
                disabled={!SecurityContext.restaurantSettings.editConfigurationPos()}
            />
          </div>
        </div>
    );
  }

  renderPosMenuId() {
    return (
        <div className="row form-group">
          <div className="col-xs-4 control-label">
            <label>{I18n.tr(
                'restaurant_edit.configuration.pos.menu_id')}</label>
          </div>

          <div className="col-xs-6">
            <TextInput
                placeholder=""
                value={this.state.posMenuId}
                onChange={this.onPosMenuIdChange}
                readOnly={!SecurityContext.restaurantSettings.editConfigurationPos()}
            />
          </div>
        </div>
    );
  }

  renderPosCredentials() {
    return (
      <div className="row form-group">
        <div className="col-xs-4 control-label">
          <label>{I18n.tr('restaurant_edit.configuration.pos.credentials')}</label>
        </div>

        <div className="col-xs-6">
          <TextInput
            placeholder=""
            value={this.state.posCredentials}
            onChange={this.onPosCredentialsChange}
            readOnly={!SecurityContext.restaurantSettings.editConfigurationPos()}
          />
        </div>
      </div>
    );
  }

  renderPosEncryptionKey() {
    return (
      <div className="row form-group">
        <div className="col-xs-4 control-label">
          <label>{I18n.tr('restaurant_edit.configuration.pos.encryption_key')}</label>
        </div>

        <div className="col-xs-6">
          <TextInput
            placeholder=""
            value={this.state.posEncryptionKey}
            onChange={this.onPosEncryptionKeyChange}
            readOnly={!SecurityContext.restaurantSettings.editConfigurationPos()}
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="edit_restaurant_form_view__private">
        <form className="form-horizontal" autoComplete="off">
          {SecurityContext.restaurantSettings.readConfigurationGeneral() && (
            <div>
              <h3 className="text-center">{I18n.tr('restaurant_edit.configuration.general')}</h3>

              <div className="top-buffer-50">
                {this.renderRestaurantName()}
                {this.renderRestaurantId()}
                {this.renderExternalId()}
                {this.renderPassword()}
                {this.renderPasswordVerification()}

                {this.renderStatus()}
              </div>
              <hr className="top-buffer-50" />
            </div>
          )}

          {SecurityContext.restaurantSettings.readConfigurationPos() && (
            <div className="top-buffer-50">
              <h3 className="text-center">{I18n.tr('restaurant_edit.configuration.pos')}</h3>

              <div className="top-buffer-50">
                {this.renderPos()}
                {this.renderPosUrl()}
                {this.renderPosId()}
                {this.renderPosMenuId()}

                {this.renderPosCredentials()}
                {this.renderPosCustomerId()}
                {this.renderPosCommentId()}
                {this.renderPosTipArticleId()}
                {this.renderPosPriceLevelId()}
                {this.renderPosUseQsrOrderNumber()}
                {this.renderPosSendArticleLineNum()}
                {this.renderPosEncryptionKey()}
              </div>
              <hr className="top-buffer-50" />
            </div>
          )}

          {this.renderButtons()}
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/pages/restaurant/edit/components/ConfigurationFormView.js